export default "__VITE_ASSET__BLSJ4JJD__"